import { useLocale } from 'next-intl';
import { normalizeLocale } from '@/utils/locale';

/**
 * 获取规范化的 locale
 * 将 useLocale() 和 normalizeLocale() 合并为一个 hook
 *
 * @returns 规范化后的完整 locale 代码（如 'hi-IN'）
 *
 * @example
 * const locale = useNormalizedLocale(); // 'hi-IN'
 */
export function useNormalizedLocale(): string {
  const locale = useLocale();
  return normalizeLocale(locale);
}
